import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// services
import { ErrorService } from '../../shared/services/error.service';
import { TitleService } from '../../shared/services/title.service';

@Component({
  selector: 'email-not-verified-component',
  templateUrl: 'email-not-verified.component.html',
  styleUrls: ['./email-not-verified.component.scss']
})
export class EmailNotVerifiedComponent implements OnInit {

  constructor(private titleService: TitleService,
    private errorService: ErrorService,
    private translate: TranslateService) { }

  ngOnInit() {
    this.titleService.set('HOME.TITLE');

    this.translate.get('ERRORS.EMAIL_NOT_VERIFIED').subscribe((res: string) => {
      this.errorService.show(res);
    });

    this.translate.onLangChange.subscribe(() => {
      this.translate.get('ERRORS.EMAIL_NOT_VERIFIED').subscribe((res: string) => {
        this.errorService.show(res);
      });
    });
  }
}
